// Assembly: Help
(function(window, document, undefined) {

  var langKeys = ["project_pct_indexed","project_pct_reviewed","project_pct_arbitrated","map_view_view_projects","map_view_featured_countries","map_view_projects_literal","project_instructions_title","field_helps_title","literal_print"];
  var langs = {
    // Included locale file: common_de.json
    "de": ["Indexiert","Durch Indexierer geprüft","Abschließend geprüft","Projekte ansehen","Verfügbare Länder","%{0} Projekt(e)","Anweisungen zum Projekt","Eingabehilfen","Drucken"],
    // Included locale file: common_en.json
    "en": ["Indexed","Reviewed","Arbitrated","View Projects","Featured Countries","%{0} projects","Project Instructions","Field Helps","Print"],
    // Included locale file: common_eo.json
    "eo": ["[Îñðéẋéð------- П國カ내]","[Ŕéṽîéŵéð--------- П國カ내]","[Åŕƀîţŕåţéð------------- П國カ내]","[Ṽîéŵ Þŕöĵéçţš------ П國カ내]","[Ƒéåţûŕéð Çöûñţŕîéš----------- П國カ내]","[%{0} þŕöĵéçţš------ П國カ내]","[Þŕöĵéçţ Îñšţŕûçţîöñš------------- П國カ내]","[Ƒîéļð Ĥéļþš---- П國カ내]","[Þŕîñţ--- П國カ내]"],
    // Included locale file: common_es.json
    "es": ["Indexados","Revisados","Arbitrados","Ver proyectos","Países con proyectos disponibles","%{0} proyectos","Instrucciones del proyecto","Ayudas para el campo","Imprimir"],
    // Included locale file: common_fr.json
    "fr": ["Indexé(s)","Vérifié(s)","Arbitré(s)","Voir les projets","Pays concernés","%{0} projets","Instructions du projet","Aides pour les champs","Imprimer"],
    // Included locale file: common_it.json
    "it": ["Indicizzato","Revisionati","Arbitrati","Visualizza progetti","Nazioni presenti","%{0} progetti","Istruzioni sul progetto","Guide per i campi","Stampa"],
    // Included locale file: common_ja.json
    "ja": ["索引作成済み","見直し済み","確認済み","プロジェクトを見る","特集の国","%{0}件のプロジェクト","プロジェクトの指示","フィールドのヘルプ","印刷"],
    // Included locale file: common_nl.json
    "nl": ["Geïndexeerd","Gecontroleerd","Gearbitreerd","Projecten bekijken","Aanbevolen landen","%{0} projecten","Projectinstructies","Veldhulp","Afdrukken"],
    // Included locale file: common_pl.json
    "pl": ["Zindeksowano","Zaopiniowano","Rozstrzygnięto","Wyświetl projekty","Wyróżnione kraje","%{0} projekty/ów","Instrukcje do projektu","Pole pomocy","Drukuj"],
    // Included locale file: common_pt.json
    "pt": ["Indexados","Revisados","Conferidos","Ver os Projetos","Países em Destaque","%{0} projetos","Instruções do Projeto","Ajuda com o Campo","Imprimir"],
    // Included locale file: common_ru.json
    "ru": ["Проиндексировано","Проверено","Выполнен арбитраж","Посмотреть проекты","Отдельные страны","Количество проектов -%{0} ","Инструкции к проекту","Справочные поля","Печать"],
    // Included locale file: common_sv.json
    "sv": ["Indexerade","Granskade av indexerare","Granskade","Visa projekt","Länder","%{0} projekt","Projektinstruktioner","Fälthjälp","Skriv ut"],
  };
  var validLocales = ["de","en","eo","es","fr","it","ja","ke","nl","pl","pt","ru","sv","zz"];

  function getLang(locales) {
    var locale, language, i, len = langKeys.length, lang = {};
    locales = (typeof locales === 'string' ? [locales] : locales);
    for (i = 0; i < locales.length; i++) {
      language = locales[i];
      if (validLocales.indexOf(language) !== -1) {
        locale = language;
        break;
      } else {
        //Check if the first two characters are a valid locale
        language = locales[i].split('-')[0];
        if (validLocales.indexOf(language) !== -1) {
          locale = language;
          break;
        }
      }
    }
    locale = locale || 'en';
    var temp;
    switch (locale) {
      case 'ke':
      case 'zz':
        for(i = 0; i < len; i++) {
          temp = (locale === 'ke' ? '[' + langKeys[i] + ']' : '[Help.' + langKeys[i] + ']');
          lang[langKeys[i]] = temp;
        }
        break;

      default:
        for(i = 0; i < len; i++) {
          lang[langKeys[i]] = langs[locale][i];
        }
        break;
    }
    return lang;
  }

  var lang = getLang(FS.simpleLocale() || 'en');

  /*
   * Included File: ../misc.js
   */
  //Plugins

  /* v1.4 */
  /* https://github.com/farinspace/jquery.imgpreload */
  if("undefined"!=typeof jQuery){(function(a){a.imgpreload=function(b,c){c=a.extend({},a.fn.imgpreload.defaults,c instanceof Function?{all:c}:c);if("string"==typeof b){b=new Array(b)}var d=new Array;a.each(b,function(e,f){var g=new Image;var h=f;var i=g;if("string"!=typeof f){h=a(f).attr("src");i=f}a(g).bind("load error",function(e){d.push(i);a.data(i,"loaded","error"==e.type?false:true);if(c.each instanceof Function){c.each.call(i)}if(d.length>=b.length&&c.all instanceof Function){c.all.call(d)}a(this).unbind("load error")});g.src=h})};a.fn.imgpreload=function(b){a.imgpreload(this,b);return this};a.fn.imgpreload.defaults={each:null,all:null}})(jQuery)}

  arrayMax = function( array ){
      return Math.max.apply( Math, array );
  };


  //Regular Code
  function supportsSVG() {
      return !! document.createElementNS && !! document.createElementNS('http://www.w3.org/2000/svg','svg').createSVGRect;
  }
  if (supportsSVG()) {
      document.documentElement.className += ' svg';
  } else {
      document.documentElement.className += ' no-svg';
  }

  function substitutePngsForSvgs(){
    if (!supportsSVG()) {

      var imgs = document.getElementsByTagName('img');
      var dotSVG = /.*\.svg$/;
      for (var i = 0; i != imgs.length; ++i) {
          if(imgs[i].src.match(dotSVG)) {
            var $img = $(imgs[i]);
            var pngFallbackSrc = $img.data('png-fallback');
            if(typeof pngFallbackSrc != 'undefined'){
              $img.attr('src',pngFallbackSrc);
            }
          }
      }
    }
  }

  substitutePngsForSvgs(); //run once at page load, accessible at window.substitutePngsForSvgs() afterward

  $(document).ready(function(){

    $('.carousel').each(function(){

      var thisCarousel = $(this);

      if(thisCarousel.length > 0){

        var carouselItems = thisCarousel.find('.item');

        if(carouselItems.length >=2){

          function resizeCarousel(){
            var windowWidth = $(window).width();
            if (windowWidth <= 767) {

              var heights = [];
              carouselItems.each(function(){
                heights.push( $(this).height() );
              });

              //console.log(heights,arrayMax(heights));
              thisCarousel.css({
                height: arrayMax(heights)+'px'
              });
            }else{
              thisCarousel.css({
                height: 'auto'
              });
            }
          }

          var carouselImagesHaveLoaded = false;
          //wait for images to preload and then resize the carousel. Also resize carousel on all window resize events.
          carouselItems.children('img').imgpreload({
            all:resizeCarousel
          });

          thisCarousel.addClass('carousel-multiple');

          thisCarousel.carousel({
            interval: 5000,
            pause:'hover'
          });

          //set up indicators
          var carouselIndicatorsContainer = $('<ol>',{'class':'carousel-indicators'});
          var carouselIndicators = $([]);

          for(var i = 0; i<carouselItems.length;i++){
            // check to see if there are multiple slides
            if(carouselItems.length > 1) {
              var thisCarouselIndicator = $('<li>');
              thisCarouselIndicator.attr('data-slide-to',''+i);
              if(i == 0){
                thisCarouselIndicator.addClass('indicator-active');
              }
              thisCarouselIndicator.appendTo(carouselIndicatorsContainer);
              carouselIndicators = carouselIndicators.add(thisCarouselIndicator); //add to carouselIndicators jquery object
            }
          }

          //resize events
          $(window).resize(resizeCarousel);
          resizeCarousel();

          carouselIndicatorsContainer.prependTo(thisCarousel);

          carouselIndicators.bind('click', function(e){
            var gotoIndex = carouselIndicators.index(this); // find the clicked indicator navigation
            carouselIndicators.removeClass('indicator-active'); // reset the indicator navigation
            $(this).addClass('indicator-active'); // mark selected to the indicator navigation
            thisCarousel.carousel(gotoIndex); // navigate to the selected slider
          });


          thisCarousel.bind('slid', function(e){ //This event is fired when the carousel has finished its slide transition.
            var currentIndex = carouselItems.index(carouselItems.filter('.active')); // find the index of current slide
            carouselIndicators.removeClass('indicator-active'); // reset the indicators
            carouselIndicators.eq(currentIndex).addClass('indicator-active'); // update the indicators

          });


        }else{
          //if there's only one item, adjust the carousel to reflect this
          carouselItems.eq(0).addClass('indicator-active');
          thisCarousel.addClass('carousel-single');
        }

      }

    });

  });

  function omnitureTrackPage(pageName) {
    if(s) {
      var channel = 'FamilySearch: Indexing:';
      s.channel = channel;
      s.pageName = channel + ' ' + pageName;
      s.t();
    }
  }


  /*
   * Included File: module.config.js
   */
  angular.module("HelpPage", ["ngRoute", "ngSanitize", "scrollto", "SecondaryNav"])

  /*
   * Included File: ../helpAccordion.directive.js
   */
  angular.module("HelpPage")

  .directive("helpAccordion", ['$routeSegment', function($routeSegment) {
    return {
      scope: true,
      link: function($scope, $element, attrs) {
        var $anchor = $element.find("a");
        var $content = $element.find(".accordion-content");

        attrs.$observe("helpAccordion", function(val) {

          if ($routeSegment.contains(val)) {
            $scope.open = true;
            $anchor.addClass("triggered");
            $content.removeClass("hide");
          }
        });
      }
    }
  }]);


  /*
   * Included File: ../MainCtrl.js
   */
  angular.module("HelpPage")

  .controller("MainCtrl", ['$scope', function($scope) {
    $scope.trackCommunityHelp = () => {
      if (FS.showEx('AnalyticsFt') && FS.Analytics && FS.Analytics.enabled()) {
        FS.Analytics.trackValue('Indexing Community Help');
      }
      if (FS.baseUrl.includes('beta.familysearch.org')) {
        window.open('https://betacommunity.familysearch.org/en/categories/indexing-support', '_blank');
      } else {
        window.open('https://community.familysearch.org/en/categories/indexing-support', '_blank');
      }
    }

  }]);


})(window, document);
